// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonials-section {
  padding: 48px 20px;
  background: white;
  box-sizing: border-box;
}

.testimonials-inner {
  max-width: 1100px;
  margin: 0 auto;
  text-align: center;
}

.testimonials-heading {
  font-size: 2rem;
  margin: 0 0 8px 0;
  color: #2b2b2b;
  font-weight: 700;
}

.testimonials-subheading {
  font-size: 1rem;
  color: #555;
  margin-bottom: 28px;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  align-items: stretch;
}

.testimonial-card {
  background: #F7FFF7;
  border: 1px solid rgba(0,0,0,0.06);
  padding: 18px;
  border-radius: 12px;
  text-align: left;
  display: flex;
  flex-direction: column;
  min-height: 200px;
  box-shadow: 0 4px 12px rgba(12,12,12,0.04);
  box-sizing: border-box;
}

.avatar-and-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #A5D6A7, #6FAF88);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: inset 0 -4px 8px rgba(0,0,0,0.06);
}

.avatar-initial {
  font-weight: 700;
  color: white;
  font-size: 20px;
}

.meta .client-name {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #222;
}

.meta .client-plan {
  margin-top: 2px;
  font-size: 0.9rem;
  color: #4a4a4a;
}

/* Review text */
.review-content {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
}

.review-text {
  margin: 0;
  color: #333;
  font-size: 0.95rem;
  line-height: 1.5;
  white-space: pre-wrap; 
}

.review-paragraph {
  margin: 0 0 8px 0;
}

.read-more-btn {
  align-self: flex-start;
  background: transparent;
  border: none;
  color: #004D40;
  font-weight: 600;
  padding: 0;
  cursor: pointer;
  font-size: 0.95rem;
  margin-top: 4px;
}

.read-more-btn:hover {
  text-decoration: underline;
}

/* Responsive breakpoints */
@media (max-width: 992px) {
  .testimonials-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .testimonials-section {
    padding: 28px 14px;
  }

  .testimonials-inner {
    max-width: 760px;
  }

  .testimonials-grid {
    grid-template-columns: 1fr;
  }

  .testimonial-card {
    padding: 14px;
  }

  .avatar {
    width: 48px;
    height: 48px;
  }

  .avatar-initial {
    font-size: 18px;
  }

  .review-text {
    font-size: 0.95rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/TestimonialsPageUpdated.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".testimonials-section {\n  padding: 48px 20px;\n  background: white;\n  box-sizing: border-box;\n}\n\n.testimonials-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.testimonials-heading {\n  font-size: 2rem;\n  margin: 0 0 8px 0;\n  color: #2b2b2b;\n  font-weight: 700;\n}\n\n.testimonials-subheading {\n  font-size: 1rem;\n  color: #555;\n  margin-bottom: 28px;\n}\n\n.testimonials-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n  align-items: stretch;\n}\n\n.testimonial-card {\n  background: #F7FFF7;\n  border: 1px solid rgba(0,0,0,0.06);\n  padding: 18px;\n  border-radius: 12px;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  min-height: 200px;\n  box-shadow: 0 4px 12px rgba(12,12,12,0.04);\n  box-sizing: border-box;\n}\n\n.avatar-and-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #A5D6A7, #6FAF88);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-shadow: inset 0 -4px 8px rgba(0,0,0,0.06);\n}\n\n.avatar-initial {\n  font-weight: 700;\n  color: white;\n  font-size: 20px;\n}\n\n.meta .client-name {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #222;\n}\n\n.meta .client-plan {\n  margin-top: 2px;\n  font-size: 0.9rem;\n  color: #4a4a4a;\n}\n\n/* Review text */\n.review-content {\n  margin-top: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex-grow: 1;\n}\n\n.review-text {\n  margin: 0;\n  color: #333;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  white-space: pre-wrap; \n}\n\n.review-paragraph {\n  margin: 0 0 8px 0;\n}\n\n.read-more-btn {\n  align-self: flex-start;\n  background: transparent;\n  border: none;\n  color: #004D40;\n  font-weight: 600;\n  padding: 0;\n  cursor: pointer;\n  font-size: 0.95rem;\n  margin-top: 4px;\n}\n\n.read-more-btn:hover {\n  text-decoration: underline;\n}\n\n/* Responsive breakpoints */\n@media (max-width: 992px) {\n  .testimonials-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .testimonials-section {\n    padding: 28px 14px;\n  }\n\n  .testimonials-inner {\n    max-width: 760px;\n  }\n\n  .testimonials-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .testimonial-card {\n    padding: 14px;\n  }\n\n  .avatar {\n    width: 48px;\n    height: 48px;\n  }\n\n  .avatar-initial {\n    font-size: 18px;\n  }\n\n  .review-text {\n    font-size: 0.95rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
